import { fabric } from 'fabric';

export const type = 'object-base';

const ObjectBase = fabric.util.createClass(fabric.Object, {
  type,
  borderColor: 'purple',
  cornerColor: 'purple',
  cornerStyle: 'circle',
  cornerSize: 8,
});

export default ObjectBase;
